import { render } from "./OrderTerms.vue?vue&type=template&id=2f356024"
import script from "./OrderTerms.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderTerms.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/orderTerms/OrderTerms.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f356024"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f356024', __exports__)) {
    console.log('reload')
    api.reload('2f356024', __exports__)
  }
  
  module.hot.accept("./OrderTerms.vue?vue&type=template&id=2f356024", () => {
    console.log('re-render')
    api.rerender('2f356024', render)
  })

}


export default __exports__